define('OutSystems/ReactWidgets/Text',["require", "exports", "tslib", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, ObjectExtensions, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Text = void 0;
    var Text = (function (_super) {
        tslib_1.__extends(Text, _super);
        function Text() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Text.prototype.render = function () {
            var attributes = {
                className: this.props.style,
            };
            this.fillWithBuiltinProperties(attributes);
            return React.createElement.apply(React, tslib_1.__spreadArrays([HtmlTags_1.HtmlTags.span, attributes], this.props.text));
        };
        Text.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
            return (!ObjectExtensions.arrayShallowEquals(this.props.text, nextProps.text) || _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState, nextContext));
        };
        Text = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Text);
        return Text;
    }(Widget_1.Widget));
    exports.Text = Text;
});
//# sourceMappingURL=Text.js.map;
